import AbstractCompositeSpecification from "./AbstractCompositeSpecification.js";

/**
 * `andSpecification` is a concrete implementation
 * of `abstractBinarySpecification` representing a server side
 * `and` operation of two other specifications.
 */
export default class AndSpecification extends AbstractCompositeSpecification {
	accept(visitor, additionalInformation) {
		return visitor.visitAndSpecification(this, additionalInformation);
	}

	isAnd() {
		return true;
	}

	static getType() {
		return "AndSpecification";
	}
}
